export const OWNER = 'owner';
export const ADMIN = 'admin';
export const BILLING = 'billing';
export const METRICS = 'metrics';
export const READONLY = 'readonly user';
export const OR_ADMIN = 'or admin';
export const OR_READONLY = 'or readonly';
export const OR_SUPERUSER = 'or superuser';
export const OR_SUPERREAD = 'or superread';

export const RolesForInvites = [
  {
    label: 'Administrator',
    value: 'admin',
  },
  {
    label: 'Billing',
    value: 'billing',
  },
  {
    label: 'Metrics',
    value: 'metrics',
  },
  {
    label: 'Owner',
    value: 'owner',
  },
  {
    label: 'Read Only',
    value: 'readonly user', // The serializer will map it to 'readonly user'
  },
];
